var exports = {
  "k": "x805b157e--62bd8a--container",
  "Q": "x805b157e--62bd8a--text",
};

module.exports = exports;
